import { render, staticRenderFns } from "./CargoEdit.vue?vue&type=template&id=fe70fe4a&scoped=true"
import script from "./CargoEdit.vue?vue&type=script&lang=js"
export * from "./CargoEdit.vue?vue&type=script&lang=js"
import style0 from "./CargoEdit.vue?vue&type=style&index=0&id=fe70fe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe70fe4a",
  null
  
)

export default component.exports